/*
 *
 * UrlTokenizationFields
 *
 * @version 1.0.0
 * @author Davide Polci
 * @since 13-Nov-2025
 */

// import React from 'react'
import { defineMessages } from 'react-intl'
// import PortalMessage from 'Hoc/PortalMessage'

const formattedMessage = {}

export const messages = defineMessages({
  notificationUrl: {
    id: 't.app.terminalsManagement.vasConfiguration.scof.notificationUrl',
    defaultMessage: 'Notification URL'
  },
  baseUrl: {
    id: 't.app.terminalsManagement.vasConfiguration.scof.baseUrl',
    defaultMessage: 'Base URL'
  },
  confirmBaseUrl: {
    id: 't.app.terminalsManagement.vasConfiguration.scof.confirmBaseUrl',
    defaultMessage: 'Confirm Base URL'
  },
  notificationUrlTooltip: {
    id: 't.app.terminalsManagement.vasConfiguration.scof.notificationUrlTooltip',
    defaultMessage:
      'A valid Notification URL must start with ‘http://www.” or ‘https://www’ (e.g., ‘https://www.example.com’ for a valid connection.'
  },
  baseUrlTooltip: {
    id: 't.app.terminalsManagement.vasConfiguration.scof.baseUrlTooltip',
    defaultMessage:
      'A valid Base URL must start with ‘http://’ or ‘https://’ (e.g., https://www.example.com). This value cannot be modified after confirmation'
  },
  confirmBaseUrlTooltip: {
    id: 't.app.terminalsManagement.vasConfiguration.scof.confirmBaseUrlTooltip',
    defaultMessage:
      'Please confirm the Base URL by re-entering it. For consistency and security, both entries must match exactly. This value cannot be modified later.'
  },
  warningAriaLabel: {
    id: 't.app.paybylink.wizard.advancedSettings.contractAndSubscription.popup.title',
    defaultMessage: 'Warning!'
  },
  Enabled: {
    id: 't.app.terminalsManagement.disputeless.details.Enabled',
    defaultMessage: 'Enabled'
  },
  Disabled: {
    id: 't.app.terminalsManagement.disputeless.details.Disabled',
    defaultMessage: 'Disabled'
  }
})
export default formattedMessage